"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_smart_scroller_1 = require("react-smart-scroller");
var index_1 = __importStar(require("../Button/index"));
var DisplayBar_1 = __importDefault(require("../DisplayBar"));
var FilterBar_1 = __importDefault(require("../FilterBar"));
var EditItemsModal_1 = __importDefault(require("../FilterBar/EditItemsModal"));
var index_2 = require("../Icon/index");
var index_3 = __importDefault(require("../LocaleProvider/index"));
var index_4 = __importDefault(require("../Modal/index"));
var index_5 = __importDefault(require("../Pagination/index"));
var DataBody_1 = __importDefault(require("./DataBody"));
var HeaderBar_1 = __importDefault(require("./HeaderBar"));
var DataTable = /** @class */ (function (_super) {
    __extends(DataTable, _super);
    function DataTable(props) {
        var _this = _super.call(this, props) || this;
        _this.updateLocale = function () {
            _this.forceUpdate();
        };
        /**
         * State export changing properties.
         */
        _this.openExport = function (format) {
            _this.setState({
                exportType: format,
            });
        };
        _this.closeExport = function () {
            _this.setState({
                exportType: undefined,
            });
        };
        _this.state = {
            exportType: undefined,
        };
        index_3.default.on(_this.updateLocale);
        return _this;
    }
    DataTable.prototype.componentWillUnmount = function () {
        index_3.default.off(this.updateLocale);
    };
    /**
     * Create export modal configurations.
     */
    DataTable.prototype.exportModal = function () {
        var _this = this;
        var _a = this.props, exportProps = _a.exportProps, paginationProps = _a.paginationProps;
        var exportType = this.state.exportType;
        var exportLocale = index_3.default.locs.datatable.export;
        var modal = null;
        if (!exportProps) {
            return modal;
        }
        var saveButton = function () {
            if (exportType) {
                exportProps.onExport(exportType);
            }
            _this.closeExport();
        };
        var modalButtons = function () { return (react_1.default.createElement("div", { style: { textAlign: "right" } },
            react_1.default.createElement(index_1.default, { icon: index_2.IconType.Save, variant: index_1.ButtonVariant.Primary, onClick: saveButton }, exportLocale.confirm))); };
        // tslint:disable:max-line-length
        var records = exportProps.maxRecords && paginationProps.totalRecords > exportProps.maxRecords
            ? exportProps.maxRecords
            : paginationProps.totalRecords;
        modal = (react_1.default.createElement(index_4.default, { open: exportType !== undefined, allowToClose: true, header: exportLocale.title + " " + (exportType !== null && exportType !== void 0 ? exportType : ""), buttons: modalButtons, onClose: this.closeExport },
            react_1.default.createElement("div", { style: { padding: "30px" } }, exportLocale.body.replace("%COUNT", String(records)))));
        return modal;
    };
    DataTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, filterProps = _a.filterProps, headerProps = _a.headerProps, paginationProps = _a.paginationProps, exportProps = _a.exportProps, displayProps = _a.displayProps;
        var localization = index_3.default.locs.datatable;
        var dataProps = __assign({}, this.props.dataProps);
        var editColumns = null;
        if (localization.editColumns && !(filterProps === null || filterProps === void 0 ? void 0 : filterProps.hideFilterSettings)) {
            editColumns = (react_1.default.createElement(EditItemsModal_1.default, { className: "without_label item", onChange: dataProps.onColumnsChange, columns: dataProps.columns, visible: dataProps.selectedColumns, editMessage: localization.editColumns, confirmMessage: localization.filters.confirm }));
        }
        var filterBar = null;
        if (filterProps) {
            dataProps.filterBarProps = __assign({ localization: localization.filters }, filterProps);
            filterBar = (react_1.default.createElement(FilterBar_1.default, __assign({ localization: localization.filters }, filterProps), editColumns));
        }
        else if (editColumns) {
            filterBar = react_1.default.createElement("div", { className: "emankit__filter_bar" }, editColumns);
        }
        var headerBar = null;
        if (headerProps) {
            headerBar = react_1.default.createElement(HeaderBar_1.default, __assign({}, headerProps));
        }
        var displayBar = null;
        if (displayProps) {
            displayBar = react_1.default.createElement(DisplayBar_1.default, __assign({ localization: localization.display }, displayProps));
        }
        // Export configuration
        var modal = this.exportModal();
        var exportItems = [];
        if (exportProps) {
            exportProps.formats.forEach(function (format) {
                exportItems.push(react_1.default.createElement(index_1.default, { icon: index_2.IconType.Download, key: "export_" + format, onClick: _this.openExport.bind(_this, format), className: "export_btn" },
                    localization.export.title,
                    " .",
                    format));
            });
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            modal,
            headerBar,
            displayBar,
            filterBar,
            react_1.default.createElement("div", { className: "emankit__data_table_container " + (this.props.dataProps.withSidebar ? "sidebar_width" : "") },
                react_1.default.createElement(react_smart_scroller_1.ReactSmartScroller, { thumb: react_1.default.createElement("div", { style: {
                            width: 100,
                            height: 10,
                            backgroundColor: "#1f3b80",
                        } }) },
                    react_1.default.createElement(DataBody_1.default, __assign({}, dataProps)))),
            react_1.default.createElement(index_5.default, __assign({}, paginationProps, { className: "pagination" }), exportItems)));
    };
    return DataTable;
}(react_1.Component));
exports.default = DataTable;
//# sourceMappingURL=index.js.map